module.exports = __webpack_public_path__ + "img/illusCorona5.399e133f.jpg";